import { render, staticRenderFns } from "./PerformerDone.vue?vue&type=template&id=b19f0980"
import script from "./PerformerDone.vue?vue&type=script&lang=js"
export * from "./PerformerDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports